import { render, staticRenderFns } from "./SignUpEmail.vue?vue&type=template&id=3c06d85d&scoped=true&"
import script from "./SignUpEmail.vue?vue&type=script&lang=js&"
export * from "./SignUpEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c06d85d",
  null
  
)

export default component.exports